<template>
  <div>
    <div class="vx-row">
      <vs-card>
        <vs-row>
          <vs-col>
            <div class="flex -mx-2">
              <div class="w-1/4 px-2">
                <p class="mt-1">Type</p>
                <v-select
                  :reduce="(rep) => rep.id"
                  class="w-full"
                  label="name"
                  v-model="category"
                  :options="categories"
                ></v-select>
              </div>
              <div class="w-1/4 px-2">
                <p class="mt-1">Client</p>
                <v-select
                  :reduce="(rep) => rep.id"
                  class="w-full"
                  label="social_reason"
                  v-model="customer"
                  :options="customers"
                ></v-select>
              </div>
              <div class="w-1/4 px-2">
                <p class="mt-1">Service</p>
                <v-select
                  :reduce="(rep) => rep.id"
                  class="w-full"
                  label="name"
                  v-model="departement"
                  :options="departements"
                ></v-select>
              </div>
              <div class="w-1/4 px-2">
                <span class="vs-select--label">Période</span>
                <date-range-picker
                  ref="picker"
                  :opens="opens"
                  :locale-data="locale"
                  :singleDatePicker="false"
                  :timePicker="false"
                  :showWeekNumbers="showWeekNumbers"
                  :showDropdowns="showDropdowns"
                  :autoApply="autoApply"
                  v-model="dateRange"
                  :ranges="false"
                  @update="updateValues"
                  :linkedCalendars="linkedCalendars"
                  :dateFormat="dateFormat"
                  :always-show-calendars="false"
                  :alwaysShowCalendars="alwaysShowCalendars"
                  class="vs-inputx vs-input--input"
                >
                  <div
                    slot="input"
                    slot-scope="picker"
                    style="min-width: 350px"
                  >
                    {{ picker.startDate | date }} - {{ picker.endDate | date }}
                  </div>
                </date-range-picker>
              </div>
            </div>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-button
            :disabled="dateRange.startDate === '' && dateRange.endDate === ''"
            @click="makeSearch()"
            class="mt-5 ml-4"
            color="primary"
            type="filled"
            icon="search"
            >Recherche
          </vs-button>

          <vs-button
            :disabled="dateRange.startDate === '' && dateRange.endDate === ''"
            @click="exportData()"
            class="mt-5 ml-2"
            color="primary"
            type="filled"
            icon="cloud_download"
            >Exporter
          </vs-button>
        </vs-row>
      </vs-card>
    </div>

    <div class="app-dashboard">
      <div class="vx-row">
        <div
          style="cursor: pointer"
          @click="exportSpecial('total')"
          class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
        >
          <vx-card
            class="overflow-hidden"
            card-background="primary"
            content-color="#fff"
          >
            <div slot="no-body">
              <div
                class="p-6 flex justify-between flex-row-reverse items-center"
              >
                <div class="truncate">
                  <h2 class="mb-1 font-bold text-white">{{ totalRequest }}</h2>
                  <span>Total</span>
                </div>
              </div>
            </div>
          </vx-card>
        </div>

        <div
          style="cursor: pointer"
          @click="exportSpecial('inProgress')"
          class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
        >
          <vx-card class="overflow-hidden">
            <div slot="no-body">
              <div
                class="p-6 flex justify-between flex-row-reverse items-center"
              >
                <div class="truncate">
                  <h2 class="mb-1 font-bold">{{ totalInProgress }}</h2>
                  <span>Total en cours</span>
                </div>
              </div>
            </div>
          </vx-card>
        </div>

        <div
          style="cursor: pointer"
          @click="exportSpecial('treat')"
          class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
        >
          <vx-card
            class="overflow-hidden"
            card-background="success"
            content-color="white"
          >
            <div slot="no-body">
              <div
                class="p-6 flex justify-between flex-row-reverse items-center"
              >
                <div class="truncate">
                  <h2 class="mb-1 text-white">{{ totalTreat }}</h2>
                  <span>Total traité</span>
                </div>
              </div>
            </div>
          </vx-card>
        </div>

        <div
          style="cursor: pointer"
          @click="exportSpecial('pending')"
          class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
        >
          <vx-card
            class="overflow-hidden"
            card-background="danger"
            content-color="white"
          >
            <div slot="no-body">
              <div
                class="p-6 flex justify-between flex-row-reverse items-center"
              >
                <div class="truncate">
                  <h2 class="mb-1 font-bold text-white">{{ totalAt }}</h2>
                  <span>Total en attente</span>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from "moment";
import { _buildQuery } from "../../helpers/helper";
export default {
  name: "totalRequest",
  components: { DateRangePicker },
  data: () => ({
    totalRequest: 0,
    totalInProgress: 0,
    totalTreat: 0,
    totalAt: 0,
    categories: [],
    user: 0,
    category: null,
    stats: [],
    requests: [],
    last_page: null,
    page: 1,
    opens: "left",
    showWeekNumbers: true,
    linkedCalendars: true,
    alwaysShowCalendars: true,
    showDropdowns: true,
    autoApply: false,
    locale: {
      direction: "ltr",
      format: "dd/mm/yyyy",
      separator: " - ",
      applyLabel: "Appliquer",
      cancelLabel: "Annuler",
      weekLabel: "W",
      customRangeLabel: "Custom Range",
      daysOfWeek: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
      monthNames: [
        "Jan",
        "Fev",
        "Mar",
        "Avr",
        "Mai",
        "Jui",
        "Juil",
        "Aou",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      firstDay: 0,
    },
    dateRange: {
      startDate: "",
      endDate: "",
    },
    dateFormat(classes, date) {
      // let yesterday = moment().subtract(1, "day");
      // if (!classes.disabled) {
      // }
      return classes;
    },
    departements: [],
    departement: null,
    customers: [],
    customer: null,
  }),
  mounted() {
    this.dateRange.startDate = moment(new Date()).format("YYYY-MM-DD");
    this.dateRange.endDate = moment(new Date()).format("YYYY-MM-DD");
    this.makeSearch();
    this.getCategories();
    this.getCustomers();
    this.getDepartements();
  },
  methods: {
    async getDepartements() {
      try {
        this.$vs.loading();
        let response = await this.$http.get("departements");
        this.departements = response.data;
        this.$vs.loading.close();
      } catch (error) {
        this.$vs.loading();
        console.log(error);
      }
    },
    async getCustomers() {
      let response = await this.$store.state.customers({}).catch((error) => {
        console.log("error: ", error);
      });

      this.customers = response.data;
    },
    updateValues(values) {
      this.dateRange.startDate = moment(values.startDate).format("YYYY-MM-DD");
      this.dateRange.endDate = moment(values.endDate).format("YYYY-MM-DD");
    },
    exportSpecial(val) {
      this.$vs.loading();
      this.$http
        .post(
          "/ebu/total-request-steep",
          {
            date_debut: this.dateRange.startDate,
            date_fin: this.dateRange.endDate,
            category: this.category,
            steep: val,
            departement: this.departement,
            customer: this.customer,
          },
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          //link.href = response.data.file
          link.href = link.href = url;
          link.setAttribute("download", "stats_globales_" + val + ".xlsx");
          document.body.appendChild(link);
          link.click();
          this.customer = "";
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "login" });
          }
        });
    },
    getCategories() {
      //this.$vs.loading()
      this.$http
        .get("/categories-requests?paginate=0")
        .then((response) => {
          this.categories = response.data;
          this.$vs.loading.close();
        })
        .catch((error) => {
          //this.$vs.loading.close()
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          } else {
            console.log(error);
          }
        });
    },

    makeSearch() {
      this.$vs.loading();
      this.$http
        .post("/ebu/total-request?export=0", {
          date_debut: this.dateRange.startDate,
          date_fin: this.dateRange.endDate,
          category: this.category,
          departement: this.departement,
          customer: this.customer,
        })
        .then((response) => {
          let content = response.data;
          this.totalRequest = content["totalRequest"];
          this.totalInProgress = content["totalInProgress"];
          this.totalTreat = content["totalTreat"];
          this.totalAt = content["totalEnt"];
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$router.push({ name: "login" });
          } else {
            console.log(error);
          }
        });
    },

    exportData() {
      this.$vs.loading();
      this.$http
        .post(
          "/ebu/total-request?export=1",
          {
            date_debut: this.dateRange.startDate,
            date_fin: this.dateRange.endDate,
            category: this.category,
            departement: this.departement,
            customer: this.customer,
          },
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          //link.href = response.data.file
          link.href = link.href = url;
          link.setAttribute("download", "Statistiques_globales.xlsx");
          document.body.appendChild(link);
          link.click();
          this.customer = "";
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "login" });
          }
        });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/components/vxTimeline.scss";
</style>
